import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

const AuthInitializer: React.FC = () => {
  const { initialize, isHydrated } = useAuthStore();

  useEffect(() => {
    // Initialize auth store after component mounts
    if (!isHydrated) {
      initialize();
    }
  }, [initialize, isHydrated]);

  return null;
};

export default AuthInitializer;
